import { useState, useEffect } from 'react'

export function useCountdown() {
  const [timeLeft, setTimeLeft] = useState({
    hours: 0,
    minutes: 30,
    seconds: 0,
  })

  useEffect(() => {
    const getDeadline = () => {
      const stored = localStorage.getItem('deadline')
      if (stored) {
        const storedTime = Number(stored)
        if (storedTime > Date.now()) return storedTime
      }
      const newDeadline = Date.now() + 30 * 60 * 1000
      localStorage.setItem('deadline', String(newDeadline))
      return newDeadline
    }

    const deadline = getDeadline()

    const interval = setInterval(() => {
      const now = Date.now()
      const difference = deadline - now

      if (difference <= 0) {
        const newDeadline = Date.now() + 30 * 60 * 1000
        localStorage.setItem('deadline', String(newDeadline))
      } else {
        const hours = Math.floor((difference / (1000 * 60 * 60)) % 24)
        const minutes = Math.floor((difference / 1000 / 60) % 60)
        const seconds = Math.floor((difference / 1000) % 60)
        setTimeLeft({ hours, minutes, seconds })
      }
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  return timeLeft
}
